import { BLACKLISTED_CATEGORIES } from '../config/settings';

export default category => !BLACKLISTED_CATEGORIES.includes(category);
